// Imports
import React from "react";
import Quiz from "../../Components/quiz.jsx";
import { QuizProvider } from "src/contexts/QuizContext.js";

const App = () => {
  return (
    <div className="app__wrapper">
      <QuizProvider>
        <Quiz />
      </QuizProvider>
    </div>
  );
};

export default App;
